export function cycleSort(previous, key) {
  if (previous?.key !== key) return { key, direction: "ascending" };
  return previous.direction === "ascending" ? { key, direction: "descending" } : null;
}
export function sortRows(rows, sort, numericKeys = [], dateKeys = []) {
  if (!sort) return rows;
  const direction = sort.direction === "ascending" ? 1 : -1;
  return rows.map((row, index) => ({ row, index })).sort((a, b) => {
    const left = a.row[sort.key]; const right = b.row[sort.key];
    const comparison = numericKeys.includes(sort.key) ? Number(left || 0) - Number(right || 0) : dateKeys.includes(sort.key) ? (Date.parse(left) || 0) - (Date.parse(right) || 0) : String(left || "").localeCompare(String(right || ""), undefined, { sensitivity: "base" });
    return comparison * direction || a.index - b.index;
  }).map(({ row }) => row);
}
